export const blockIconsMapsBusinessCenterNew = (
	<span className='material-symbols-outlined'>business_center</span>
);
